import 'rxjs'
import {ajax} from 'rxjs/observable/dom/ajax'
import config from '../config'
import errorHandlerBuilder from './errorHandlerBuilder'
import {
  ACTION_ENTERPRISE_ACCOUNT_UPDATE_ERROR,
  ACTION_ENTERPRISE_ACCOUNT_UPDATE_LOADING,
  ACTION_ENTERPRISE_ACCOUNT_UPDATE_LOADED,
  PATH_ENTERPRISE_ACCOUNTS_V2,
  EVENT_ENTERPRISE_ACCOUNT_UPDATED, EVENT_USER_UPDATED
} from '../constants'

const api_server_host = config.api_server_host

const errorHandler = errorHandlerBuilder(ACTION_ENTERPRISE_ACCOUNT_UPDATE_ERROR)

const epic = (action$, store) =>
  action$.ofType(ACTION_ENTERPRISE_ACCOUNT_UPDATE_LOADING)
    .mergeMap(action => {

      const tokenData = store.getState().user
      const token = tokenData.access_token
      const type = tokenData.token_type

      return ajax({
        method: 'PUT',
        url: `${api_server_host}${PATH_ENTERPRISE_ACCOUNTS_V2}/${action.payload.id}`,
        headers: {
          Authorization: `${type} ${token}`,
          'Content-Type': 'application/json'
        },
        body: action.payload,
        responseType: 'json'
      }).map(data=> {

        const payload = data.response
        payload.message = 'Enterprise Account Updated'

        return {
          type: ACTION_ENTERPRISE_ACCOUNT_UPDATE_LOADED,
          payload
        }
      }).rxEmit(EVENT_ENTERPRISE_ACCOUNT_UPDATED).catch(errorHandler)

    })
export default epic




// WEBPACK FOOTER //
// ./src/epics/EnterpriseAccountUpdateEpic.js